import {Routes} from '@angular/router';
import {MobileMenuComponent} from '@odp/shared/lib/mobile-menu/mobile-menu.component';

export const COVID19_VARIANT_ROUTES: Routes = [
  {
    path: 'activity',
    loadChildren: () => import('./lazy-routes/activity.routes').then((m) => m.ActivityRouteModule)
  },
  {
    path: 'pandemic-history',
    loadChildren: () =>
      import('./lazy-routes/circulating-variants.routes').then((m) => m.CirculatingVariantsRouteModule)
  },
  {
    path: 'summary',
    loadChildren: () => import('./lazy-routes/summary.routes').then((m) => m.SummaryRouteModule)
  },
  {
    path: 'trace',
    loadChildren: () => import('./lazy-routes/trace.routes').then((m) => m.TraceRouteModule)
  },
  {
    path: 'datasets',
    loadChildren: () => import('./lazy-routes/datasets.routes').then((m) => m.DatasetsRouteModule)
  },
  {
    path: 'heterologous-booster',
    loadChildren: () =>
      import('./lazy-routes/heterologous-booster.routes').then((m) => m.HeterologousBoosterRouteModule)
  },
  {
    path: 'multivalent-booster',
    loadChildren: () => import('./lazy-routes/bivalent-booster.routes').then((m) => m.BivalentBoosterRouteModule)
  },
  {
    path: 'assays',
    loadComponent: () => import('./features/assay/assay/assay.component').then((m) => m.AssayComponent)
  },
  {
    path: 'assays/:id/:assay',
    component: MobileMenuComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/assay/overview/overview.component').then((m) => m.AssayOverviewComponent)
      }
    ]
  },
  {
    path: 'in-vivo',
    loadChildren: () => import('./lazy-routes/in-vivo.routes').then((m) => m.InVivoRouteModule)
  },
  {
    path: 'real-world-evidence',
    loadChildren: () => import('./lazy-routes/rwe.routes').then((m) => m.RWERouteModule)
  },
  {
    path: 'real-world-evidence-forest-plot',
    loadChildren: () => import('./lazy-routes/rwe-forestplot.routes').then((m) => m.RWEForestplotRouteModule)
  },
  {
    path: 'related-resources',
    loadChildren: () => import('./lazy-routes/related-resources.routes').then((m) => m.RelatedResourcesRouteModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./lazy-routes/about.routes').then((m) => m.VariantAboutRouteModule)
  }
];
